module.exports = __webpack_public_path__ + "static/media/photo223.c6986dda.jpg";